import BaseSkeleton from "@/components_v2/Skeleton/BaseSkeleton";
import MissingValue from "@/features/certifications/participants/components/MissingValue";
import { StatCardProps } from "@/features/certifications/admin/components/types";

import "./styles.css";

const StatCard = ({ label, value, isLoading, hint }: StatCardProps) => (
  <div className="admin-stat-card flex-1 flex flex-col gap-100" title={hint}>
    <dt className="admin-stat-label body-m-regular">{label}</dt>

    <dd className="admin-stat-value header-l-medium">
      {isLoading && <BaseSkeleton width="3rem" height="var(--spacing-500)" />}

      {!isLoading && value !== null && value}

      {!isLoading && value === null && <MissingValue />}
    </dd>
  </div>
);

export default StatCard;
